module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_08.8b8e60ea.jpg";